import { Auth } from 'aws-amplify';

export async function getAwsUserId(): Promise<string> {
    try {
        const currentUserInfo = await Auth.currentUserInfo();
        const userId = currentUserInfo.username;
        return userId;
    } catch (error) {
        console.error('Error fetching AWS user ID:', error);
        throw new Error('Unable to retrieve AWS user ID');
    }
}